import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import { createStyles, StyledComponentProps, withStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { observer } from 'mobx-react';
import { getSnapshot, Instance, types } from 'mobx-state-tree';
import * as React from 'react';
import { IEntity } from '../../main/entities';
import { transl } from '../../main/transl';
import { commSvc, IOcResponse } from '../../services/CommSvc';
import { toasterSvc } from '../../services/ToasterSvc';
import { getOmnistore } from '../../stores/Omnistore';

type ITemplateItem = IEntity & {templateId: number, category: string}

type IParams = {templateId: number, items: Array<ITemplateItem>}

export const SetCategoryDialogStore = types
	.model('SetCategoryDialogStore', {
		entities: types.array(types.frozen<IEntity>()),
		category: '',
	})
	.volatile(self => ({
		_reject: null as any,
		_resolve: null as any,
		_fetchCurrentCategories: null as null | (() => void),
	}))
	.actions(self => ({
		applyEvent(event: React.SyntheticEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) {
			const t = event.target as any;
			if (t instanceof HTMLInputElement && t.type==='checkbox') {
				self[t.name] = !self[t.name];
			} else {
				self[t.name] = t.value;
			}
		},
		setCategory(event: React.ChangeEvent<{}>, value: string | null) {
			self.category = value ?? '';
		},
		start(entities: Array<IEntity>) : Promise<any> {
			self.entities.clear();
			entities.forEach(e => self.entities.push(e));
			return new Promise((resolve, reject) => {
				self._resolve = resolve;
				self._reject = reject;
			});
		},
		close() {
			self.entities.clear();
			self.category = '';
		},
		setFetchCurrentCategories(fetchCurrentCategories: () => void) {
			self._fetchCurrentCategories = fetchCurrentCategories;
		},
	}))
	.actions(self => ({
		cancel() {
			self.close();
			self._reject();
		},
		accept() {
			const entities = getSnapshot(self.entities) as Array<ITemplateItem>; //TODO 9
			const byTemplateId : Map<number, IParams> = new Map();
			entities.forEach(e => byTemplateId.set(e.templateId, {templateId: e.templateId, items: []}));
			entities.forEach(e => byTemplateId.get(e.templateId)!.items.push({...e, category: self.category}));

			const send = (params: IParams) =>
				commSvc.doPost('UpdateTemplateItems', params)
					.then(commSvc.requireOutputList)
					.then((r: IOcResponse) => {
						getOmnistore().multirepo.templateItemRepo(params.templateId).fetchDirect();
						return r;
					})
					.catch(e => {
						toasterSvc.failure(e);
						return false;
					});

			const promises = [...byTemplateId.values()].map(send);
			Promise.all(promises).then((arr) => {
				const fullSuccess = arr.reduce((a, b) => a && b);
				const someSuccess = arr.reduce((a, b) => a || b);
				someSuccess ? self._resolve() : self._reject();
				if (fullSuccess) {
					toasterSvc.success('SetCategory.success');
				} else if (someSuccess) {
					console.log('partial', arr);
				}
				self._fetchCurrentCategories!();
			})
				.finally(() => {
					self.close();
				});
		},
	}));

type ISetCategoryDialogProps = {
	store: Instance<typeof SetCategoryDialogStore>
	isOpen: boolean
	categories: Array<string>
	fetchCurrentCategories: () => void
}

@observer class _SetCategoryDialog extends React.Component<ISetCategoryDialogProps & StyledComponentProps> {
	render() {
		const {store, isOpen, categories} = this.props;
		if (!isOpen) return null;
		store.setFetchCurrentCategories(this.props.fetchCurrentCategories);
		const nEntities = store.entities.length;
		return <Dialog open={!!store.entities.length}>
			<DialogTitle>{transl('SetCategory')}</DialogTitle>
			<DialogContent>
				{
					nEntities===1 ? transl('SetCategoryToNItems1') : transl('SetCategoryToNItems2', nEntities)
				}
				<Autocomplete
					freeSolo
					options={categories}
					multiple={false}
					onChange={store.setCategory}
					renderInput={params => (
						<TextField {...params}
							fullWidth
							name="category"
							label={transl('category')}
							value={store.category}
							onChange={store.applyEvent}
						/>
					)}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={store.accept} color="primary">
					{transl('SetCategory.accept')}
				</Button>
				<Button onClick={store.close}>{transl('cancel')}</Button>
			</DialogActions>
		</Dialog>;
	}
}

const styles = createStyles({
});

export const SetCategoryDialog = withStyles(styles)(_SetCategoryDialog);
